import { DataExplorerFolder } from "./DataExplorerFolder";
import { DataExplorerValue } from "./DataExplorerValue";


export interface DataExplorerNodeProps {
    data: Record<string, any>,
    depth: number,
    download: any,
    selectTensor: any,
    selectedTensor: any;
    expanded: string[];
    toggleExpanded: (p: string) => void;
}

export const DataExplorerNode = (props: DataExplorerNodeProps) => {
    const { data, depth, download, selectTensor, selectedTensor, expanded, toggleExpanded } = props;

    return (<ul className="data-explorer-node">
        {Object.keys(data).map(key => {
            const value = data[key];
            const args = { name: key, depth, download, selectTensor, selectedTensor, expanded, toggleExpanded };

            if (value.type === 'folder') {
                return <DataExplorerFolder key={key} data={value} {...args} />;
            } else if (value.type === 'value') {
                return <DataExplorerValue key={key} data={value} {...args} />;
            }
        })}
    </ul>);
};
